<template>
  <!-- 订单号 -->
  <div class="pannel">
    <table class="details" style="">
      <tr>
        <td>{{$t("main['订单号']")}}:&nbsp;</td>
        <td colspan="2">
          <span style="color: grey;"> {{orderInfo.orderId|orderIdShow}}
          </span>
        </td>
      </tr>
      <tr>
        <td>{{$t("main['金额']")}}:&nbsp;</td>
        <td>
          <span style="color: red;"><b>{{orderInfo.amount}}</b></span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
  filters: {
    orderIdShow(value) {
      if (!value) return "";
      value =
        value.substring(0, 4) + "********" + value.substring(12, value.length);
      return value;
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
